export default (error) => _.has(error, 'response.data.error.message');
